import { useNavigate } from 'react-router-dom';
import AppShell from '../components/AppShell.tsx';
import ExperimentForm from '../components/ExperimentForm.tsx';
import { apiClient } from '../lib/api.ts';

export default function ExperimentNewPage() {
  const navigate = useNavigate();

  return (
    <AppShell>
      <main className="mx-auto max-w-2xl px-6 py-10">
        <h1 className="text-3xl">New experiment</h1>
        <p className="mt-2 text-ink-muted">
          One audience, one message, one offer, one count. Everything else is a different test.
        </p>
        <div className="mt-8 rounded-xl border border-border bg-surface p-6 shadow-card">
          <ExperimentForm
            submitLabel="Create experiment"
            onSubmit={async (fields) => {
              const created = await apiClient.createExperiment(fields);
              navigate(`/app/experiments/${created.experiment.id}`);
            }}
          />
        </div>
      </main>
    </AppShell>
  );
}
